<template>
    <div class="map-events-list-bg">
        <h1 class="map-events-list-header">Lista zdarzeń na mapie</h1>
        <div class="map-events-list-table">
            <h2 class="map-events-list-info">Sprawdź zdarzenia w swojej okolicy</h2>
            <div class="flex mr-6 ml-3 gap-4 map-events-list-outer">
                <div class="flex flex-column w-2 map-events-list">
                    <div :class="tableType === 'failure' ? 'legend-item active' : 'legend-item'"
                         @click="() => tableType = 'failure'"
                         @keydown.enter="() => tableType = 'failure'" tabindex="0">
                        <img class="legend-icon" src="@/assets/lightning_cluster.svg"
                             alt="błyskawica - potwierdzona przez naszych specjalistów awaria,
                                która jest w trakcie usuwania"/>
                        <p class="item-desc"> Potwierdzone awarie</p>
                    </div>
                    <div :class="tableType === 'planned' ? 'legend-item active' : 'legend-item'"
                         @click="() => tableType = 'planned'"
                         @keydown.enter="() => tableType = 'planned'" tabindex="0">
                        <img class="legend-icon" src="@/assets/pylon_cluster.svg"
                             alt="słup energetyczny - planowane wyłączenie dostawy energii związane
                                z potrzebą przeprowadzenia prac technicznych"/>
                        <p class="item-desc"> Planowane wyłączenia </p>
                    </div>
                    <div :class="tableType === 'user' ? 'legend-item active' : 'legend-item'"
                         @click="() => tableType = 'user'"
                         @keydown.enter="() => tableType = 'user'" tabindex="0">
                        <img class="legend-icon" src="@/assets/notification_bell_cluster.svg"
                             alt="dzwonek - zgłoszenie użytkownika,
                                które jest w trakcie sprawdzania przez naszych specjalistów"/>
                        <p class="item-desc"> Zgłoszenia użytkowników</p>
                    </div>
                </div>
                <div class="w-10 map-events-list-tables">
                    <FailureTable v-if="tableType === 'failure'" ref="failureTable" />
                    <PlannedTable v-if="tableType === 'planned'" ref="plannedTable" />
                    <UserReportsTable v-if="tableType === 'user'" ref="userReportsTable" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FailureTable from "./components/FailureTable";
    import UserReportsTable from "./components/UserReportsTable";
    import PlannedTable from "./components/PlannedTable";
    import EonRadioButton from "../../components/form/EonRadioButton";

    export default {
        name: "MapEventsListPublicView",
        components: {
            FailureTable,
            UserReportsTable,
            PlannedTable,
            EonRadioButton,
        },
        data() {
            return {
                tableType: "failure",
            };
        },
    };
</script>

<style lang="less">
    @import "@/assets/theme/variable.less";
    .map-events-list-bg {
        background-image: url("../../assets/plannedBG.jpg");
        background-attachment: fixed;
        background-size: cover;
        padding-top: 3.75em;
    }
    .map-events-list-header {
        color: white;
        margin-top: 40px;
        margin-bottom: 40px;
        margin-left: 10%;
        font-size: 6.25rem;
        text-align: left;
        @media screen and (max-width: 600px) {
            margin-left: 10px;
        }
        @media screen and (max-width: 550px) {
            font-size: 4.75rem;
        }
        @media screen and (max-width: 450px) {
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 2.25rem;
        }
    }
    .map-events-list-info {
        color: #00568f;
        font-size: 2rem;
        text-align: left;
        margin-left: 4%;
        font-weight: bold;
        @media screen and (max-width: 550px) {
            font-size: 1.75rem;
        }
        @media screen and (max-width: 450px) {
            font-size: 1.125rem;
        }
        &__red {
            color: @tint-bordeaux-00;
            font-size: 1.375rem;
            @media screen and (max-width: 550px) {
                font-size: 1.125rem;
            }
            @media screen and (max-width: 450px) {
                font-size: 1rem;
            }
        }
    }
    .map-events-list-outer {
        @media screen and (max-width: 1380px) {
            flex-direction: column;
            .map-events-list, .map-events-list-tables {
                width: 100% !important;
            }
            .map-events-list {
                flex-direction: row !important;
                justify-content: space-between;
                flex-wrap: wrap;
            }
        }
    }
    .map-events-list {
        .legend-item {
            display: flex;
            align-items: center;
            justify-content: start;
            gap: 1rem;
            padding: 0.5rem;
            cursor: pointer;
            &:hover {
                background-color: @color-grey-ultralight;
            }
            &.active {
                background-color: @color-grey-ultralight;
                .item-desc {
                    color: @color-red;
                }
            }
            .legend-icon {
                height: 32px;
                width: 32px;
            }
        }
    }
    .map-events-list-table {
        background-color: white;
        width: 80%;
        margin-left: 10%;
        margin-right: 10%;
        //margin-bottom: 50px;
        padding-top: 10px;
        min-height: calc(100vh - 306px);
        @media screen and (max-width: 600px) {
            margin: 0 10px;
            width: auto;
        }
    }
    .map-events-list-tabs {
        margin-left: 59px;
        margin-right: 59px;
        .p-accordion-tab {
            box-shadow: none !important;
        }
        .p-accordion-tab-active {
            margin-bottom: 0 !important;
            & .p-accordion-header a:focus {
                text-decoration: none;
            }
        }
        .p-accordion-tab .p-accordion-header a {
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
            font-size: 1.5rem;
            font-weight: bold;
            &:hover, &:active, &:focus {
                text-decoration: none;
            }
            &:focus {
                z-index: 0;
            }
            & .p-accordion-toggle-icon {
                margin-right: -8px;
            }
            & .pi-chevron-right::before, & .pi-chevron-down::before {
                color: @secondary-color;
            }
        }
    }
    html[data-font-size='2'] {
        .map-events-list-header {
            margin-left: 5%;
        }
        .map-events-list-table {
            margin-left: 5%;
            margin-right: 5%;
            width: 90%;
        }
    }
</style>
